import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "73",
  height: "65",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#D7DDF6",
      stroke: "#D7DDF6",
      "stroke-linejoin": "round",
      "stroke-width": "4",
      d: "M36.5 70.25c18.64 0 33.75-15.11 33.75-33.75S55.14 2.75 36.5 2.75 2.75 17.86 2.75 36.5 17.86 70.25 36.5 70.25Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#EBEEFB",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "4",
      d: "m36.512 16.25-.002 20.265 14.31 14.309"
    }, null, -1)
  ])))
}
export default { render: render }